import { FilmScreening } from '@/app/[locale]/(rest)/films/[slug]/components/ScreeningList';
import { formatDate } from '@/utils/date-format';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Image from '../Image';
import Button from '../ui/Button';

export enum ScreeningType {
    'ONLINE' = 'virtualExclusive',
    'OFFLINE' = 'inCinema',
}

const Screening = ({
    screening: {
        start_time: date,
        location: { name: place, address: description },
    },
    onAddToBasket,
    onRemoveFromBasket,
    isAddedInitially,
    disabled,
}: {
    screening: FilmScreening;
    onAddToBasket: () => void;
    onRemoveFromBasket: () => void;
    isAddedInitially: boolean;
    disabled?: boolean;
}) => {
    const t = useTranslations('Cart');
    const [isAdded, setIsAdded] = useState(isAddedInitially || false);

    const handleAddToBasket = () => {
        if (!isAdded) {
            onAddToBasket();
            setIsAdded(true);
        } else {
            setIsAdded(false);
            onRemoveFromBasket();
        }
    };

    return (
        <div className="flex flex-col">
            <span className="font-helvetica-neue font-light text-p max-lg:text-[12px] text-tofu w-full border-b border-white">
                {formatDate(date)}
            </span>
            <div className="flex gap-10 justify-between pt-5 items-end max-lg:flex-col max-lg:items-start max-lg:gap-5">
                <div className="flex flex-col">
                    <h5 className="text-[22px] lg:text-[28px] uppercase text-white">{place}</h5>
                    <p className="font-helvetica-neue font-light text-p text-tofu max-lg:text-[12px]">
                        {description}
                    </p>
                </div>
                <Button
                    className={cn(
                        `max-w-80 w-full border-primary border border-solid py-3 px-20 h-fit transition-colors duration-300 ${
                            isAdded ? 'bg-primary text-white' : ''
                        }`,
                        disabled && 'opacity-50 cursor-not-allowed',
                    )}
                    onClick={handleAddToBasket}
                    variant="primary"
                    title={disabled ? t('notAvailable') : isAdded ? t('added') : t('addToBasket')}
                    textClasses="font-trade-gothic font-normal text-white"
                    disabled={disabled}
                >
                    <Image
                        className={`ml-4 ${isAdded ? 'brightness-0 invert' : ''}`}
                        src="/img/icons/basket.svg"
                        alt="Basket Icon"
                        width={36}
                        height={36}
                    />
                </Button>
            </div>
        </div>
    );
};

export default Screening;
